/* eslint-disable react/require-default-props */
import React from 'react';

interface SectionCardProps {
  title: string;
  icon?: string;
  children: React.ReactNode;
  onToggle?: () => void;
  rightContent?: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({
  title,
  icon,
  children,
  onToggle,
  rightContent,
}) => {
  return (
    <div className="card border rounded mb-4">
      <div className="card-header d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          {icon && <i className="material-icons mr-2">{icon}</i>}
          <strong className="mb-0">{title}</strong>
        </div>

        <div className="d-flex align-items-center">
          {rightContent}

          {onToggle && (
            <button
              type="button"
              className="btn btn-link p-0 ml-2 d-flex align-items-center"
              onClick={onToggle}
            >
              <i className="material-icons">expand_less</i>
            </button>
          )}
        </div>
      </div>
      <div className="card-body">{children}</div>
    </div>
  );
};

export default SectionCard;
